export default "__VITE_ASSET__ByXjpCmu__"